export const AUTOCOMPLETE_SEARCH_USERS_IN_PROGRESS = "AutocompleteSearchUsersInProgress";
export const AutoCompleteSearchUsersInProgress = () => ({
  type: AUTOCOMPLETE_SEARCH_USERS_IN_PROGRESS,
});

export const AUTOCOMPLETE_SEARCH_USERS_SUCCESS = "AutocompleteSearchUsersSuccess";
export const AutoCompleteSearchUsersSuccess = (data) => ({
  type: AUTOCOMPLETE_SEARCH_USERS_SUCCESS,
  payload: { data },
});

export const AUTOCOMPLETE_SEARCH_USERS_FAILURE = "AutoCompleteSearchUsersFailure";
export const AutoCompleteSearchUsersFailure = () => ({
  type: AUTOCOMPLETE_SEARCH_USERS_FAILURE,
});

export const AUTOCOMPLETE_SEARCH_USERS_CLEAR = "AutoCompleteSearchUsersClear";
export const AutoCompleteSearchUsersClear = () => ({
  type: AUTOCOMPLETE_SEARCH_USERS_CLEAR,
});


